import { createNamespacedHelpers } from 'vuex'
const {
  mapActions: commonMapActions
} = createNamespacedHelpers('common')
export default {

  data () {
    return {
      tabList:[],
      stepCode: null,
      tabStep: ''
    }
  },

  computed: {

  },
  watch: {
    '$route': {
      handler (to, from) {
        let path = to.path
        path = path.split('/').pop()
        if (this.tabList.length > 0) {
          if (path !== 'proposalMain' || path !== 'steps') {
            this.stepCode = path
            this.tabStep = ''
            let item = this.tabList.find(obj => {
              return obj.rt === path
            })
            if (item) {
              this.tabStep = item.step
            }
          } else {
            this.stepCode = null
            this.tabStep = ''
          }
        }

      },
      immediate: true
    },
    tabStep (v) {
      if (v) {
        let toPreStep = ''
        let toNextStep = ''
        let item = this.tabList.find(obj => {
          return obj.step === this.tabStep
        })
        if (item) { // 要跳過去的的step設成disabled
          item.disabled = true
          toPreStep = item.preStep
          toNextStep = item.nextStep
        }
        while (toPreStep) {
          // 目前的step之前的設成非disabled
          item = this.tabList.find(obj => {
            return obj.step === toPreStep
          })
          if (item) {
            item.disabled = false
            toPreStep = item.preStep
          } else {
           break
          }
        }
        const isDev = process.env.NODE_ENV === 'development'
        while (toNextStep) {
          // 目前的step之後的設成disabled
          item = this.tabList.find(obj => {
            return obj.step === toNextStep
          })
          if (item) {
            if (isDev) {
              item.disabled = false
            } else {
              item.disabled = true
            }
            toNextStep = item.nextStep
          } else {
            break
          }
        }
      }
    }

  },

  methods: {
    ...commonMapActions(['postUserAccessLog']),
    $postUserAccessLog (params) {
      const { transCode } = this
      params.transCode = transCode
      return this.postUserAccessLog(params)
    }

  }
}
